<template>
  <OutlinedCard
    :title="$t('modules.portalalumno.procedures.retirement.userData.title')"
    :subtitle="$t('modules.portalalumno.procedures.retirement.userData.subtitle')"
    class="card-container"
  >
    <div class="my-4">
      <div v-for="(value, key) in formattedUserData" :key="key" class="py-2">
        <label class="mr-2">{{ value.label }}</label>
        <span>{{ value.data }}</span>
      </div>
    </div>

    <div class="action-buttons d-flex">
      <Button
        outlined
        color="primary"
        class="button outlined"
        @clicked="openPopup"
        :disabled="isUserDataEmptyDueToError"
        :text="$t('modules.portalalumno.procedures.retirement.userData.updateUserData')"
      />
    </div>
    <UserDataPopUp :value="modalOpen" @input="modalOpen = $event" @confirm="handleConfirm" :studentUserData="studentUserData" :userDataUpdate="userData"/>
  </OutlinedCard>
</template>

<script>
import OutlinedCard from '@/components/OutlinedCard/OutlinedCard';
import Button from '@/components/Button/Button';
import UserDataPopUp from '../UserDataPopUp/UserDataPopUp.vue';
import {$updatePhoneAndEmail} from '../../services/index';
import {$getPhoneAndEmail} from '../../services/index';


export default {
  name: 'UserDataReview',
  components: {
    OutlinedCard,
    Button,
    UserDataPopUp
  },
  props: {
    studentId: { type: Number },
    studentUserData: {type: Object}
  },
  data() {
    return {
      modalOpen: false,
      userData: {},
      userDataError: false,
    };
  },
  computed: {
    formattedUserData() {
      return {
        name: { label: this.$t('modules.portalalumno.procedures.retirement.userData.user.userName'), data: `${this.studentUserData.name || ''} ${this.studentUserData.lastname || ''}` },
        rut: { label: this.$t('modules.portalalumno.procedures.retirement.userData.user.rut'), data: this.studentUserData.identification || '' },
        phone: { label: this.$t('modules.portalalumno.procedures.retirement.userData.user.phone'), data: this.userData.phone || '' },
        email: { label: this.$t('modules.portalalumno.procedures.retirement.userData.user.email'), data: this.userData.email || '' },
      };
    },
    isUserDataEmptyDueToError() {
      return this.userDataError;
    }
  },
  methods: {
    openPopup() {
      this.modalOpen = true;
    },
    async handleConfirm(updatedData) {
      try {
        await $updatePhoneAndEmail.updateUser(this.studentId, null, updatedData);
        this.userData = { ...this.userData, ...updatedData };
        this.modalOpen = false;
      } catch (error) {
        this.$store.dispatch('commons/openPopUp', {
          title: 'Error',
          content: [{ value: this.$t('modules.portalalumno.procedures.retirement.error.updateUser') }],
          actionPrimary: { text: this.$t('actions.accept'), callback() {} },
          icon: { color: 'error', name: 'mdi-close' },
          color: 'primary',
        });
        throw error;
      }
    },
    async getUserData() {
      try {
        const {data} = await $getPhoneAndEmail.getUser(this.studentId, null);
        this.userData = data;
        this.userDataError = false;

        const isEmpty = !data || Object.keys(data).length === 0;
        this.$emit('userDataEmpty', isEmpty);
      } catch (error) {
        this.userDataError = true;
        this.$emit('userDataEmpty', true);

        this.$store.dispatch('commons/openPopUp', {
          title: 'Error',
          content: [{ value: this.$t('modules.portalalumno.procedures.retirement.error.getUserData') }],
          actionPrimary: { text: this.$t('actions.accept'), callback() {} },
          icon: { color: 'error', name: 'mdi-close' },
          color: 'primary',
        });
        throw error;
      }
    }
  },
  mounted() {
    this.getUserData();
  }
};
</script>
